import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import appConfigurationReducer from './reducers/appConfiguration';
import messagesReducer from './reducers/messages';
const store = configureStore({
    middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: true }),
    reducer: {
        appConfiguration: appConfigurationReducer,
        messages: messagesReducer,
    },
});
export const useAppDispatch = () => useDispatch();
export default store;
//# sourceMappingURL=index.js.map